// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"0cce08e8","451":"dd7bb5b8","453":"762a733a"}[chunkId] + ".chunk.js";
};